module.exports = __webpack_public_path__ + "static/media/audit.f5fab0c9.svg";